<template>
  <div>
    <div
      style="margin-bottom: 0"
      class="columns is-gapless is-mobile has-background-white is-minH50p is-border">
      <div class="column is-padding-left is-padding-right is-self-centered">
        <span
          style="font-weight: 400"
          class="is-uppercase title is-6">Prix du Lot</span>
      </div>
    </div>
    <div
      style="margin-bottom: 0"
      class="columns is-gapless is-mobile has-background-light is-border-bottom is-border-left is-border-right">
      <div
        style="flex-direction: column; gap: 5px"
        class="is-12 is-flex is-padding-left is-padding-right is-padding-top is-self-centered">
        <span
          style="font-weight: 400"
          class="title is-2 is-margin-bottom-xxsmall">Prix {{ childSelectedPack === null ? 'immo TTC : ' : 'PACK ' + childSelectedPack.name + ' : ' }}<span class="has-text-weight-bold">{{ childSelectedPack === null ? reservation.sale_price_ttc : childSelectedPack.sale_price_ttc }} €</span>
        </span>
        <div
          style="gap: 10px;"
          class="is-flex is-margin-bottom-xsmall">
          <div
            v-if="childSelectedPack === null"
            class="select">
            <select
              v-model="reservation.tva"
              @change="$emit('update-tva', reservation.tva, reservation.sale_price_ttc, null)">
              <option
                v-for="(tvaVal, idx) in tvaList"
                :value="tvaVal"
                :key="tvaVal + '-' + idx">
                <span v-if="tvaVal !== 'autre'">TVA {{ tvaVal | tvaLabelRounded }}%</span>
                <span v-else>autre</span>
              </option>
            </select>
          </div>
          <div class="is-flex is-nowrap is-align-items-center">
            <span
              class="is-uppercase is-size-5">Prix HT : {{ childSelectedPack === null ? reservation.sale_price_ht : childSelectedPack.sale_price_ht }} €
            </span>
          </div>
        </div>
      </div>
    </div>
    <div
      class="has-background-white is-border-bottom is-border-left is-border-right">
      <div
        v-if="lot.nature !== 'parking'"
        style="gap: 10px; flex-direction: column"
        class="is-flex is-padding is-self-centered">
        <div
          class="is-flex is-nowrap has-cursor-pointer"
          style="gap: 10px; width: 100%"
          @click="updateSelectedPack(null)">
          <i
            class="fas fa-check has-text-centered is-padding-small"
            :class="childSelectedPack === null ? 'has-background-success' : 'has-background-white'"
            style="font-size: 2rem"
            :style="childSelectedPack === null ? 'color: white' : 'color: #EBEBEB; border: solid 0.7px #EBEBEB'"></i>
          <div
            class="is-padding-small"
            :class="childSelectedPack === null ? 'has-background-success' : 'has-background-white'"
            :style="childSelectedPack === null ? 'color: white' : 'border: solid 0.7px #EBEBEB'"
            style="height: 50px; width: 100% ; flex-grow: 0">
            Prix immo :
            <span
              class="is-uppercase has-text-weight-bold"
              v-if="reservation.sale_price_ttc">{{ reservation.sale_price_ttc }} € TTC</span>
          </div>
        </div>
        <div
          class="is-flex"
          style="flex-direction: column; gap: 10px">
          <div
            style="gap: 10px; width: 100%"
            class="is-flex has-cursor-pointer"
            v-for="(pack, idx) in packList"
            :key="pack.name + '-' + idx"
            @click="updateSelectedPack(pack)">
            <i
              class="is-flex fas fa-check has-text-centered is-padding-small"
              :class="childSelectedPack && childSelectedPack.pk === pack.pk ? 'has-background-success' : 'has-background-white'"
              style="font-size: 2rem; align-items: center"
              :style="childSelectedPack && childSelectedPack.pk === pack.pk ? 'color: white' : 'color: #EBEBEB; border: solid 0.7px #EBEBEB'"></i>
            <div
              class="is-padding-small"
              :class="childSelectedPack && childSelectedPack.pk === pack.pk ? 'has-background-success' : 'has-background-white'"
              :style="childSelectedPack && childSelectedPack.pk === pack.pk ? 'color: white' : 'border: solid 0.7px #EBEBEB'"
              style="min-height: 50px; width: 100% ; flex-grow: 0;">
              Prix PACK
              <span class="is-uppercase">{{ pack.name }} :</span>&nbsp;
              <span
                class="has-text-weight-bold"
                v-if="pack.sale_price_ttc">{{ pack.sale_price_ttc.toFixed(2) }} € TTC</span>
              <br>
              <div
                class="is-padding-top-small"
                style="max-width: 600px; width: 100%"
                v-if="pack.description">
                <span class="is-uppercase has-text-weight-bold is-size-6">Descriptif</span>
                <b
                  class="is-size-6 has-text-weight-light is-uppercase"
                  v-html="pack.description"></b>
              </div>
            </div>
          </div>
          <template v-if="!isPending">
            <div
              v-for="(parking, idx) in parkings"
              :key="idx"
              style="border: solid 0.7px #EBEBEB"
              class="has-background-white is-padding-right ">
              <div class="columns is-gapless is-vcentered is-minH50p">
                <div
                  v-if="childCheckParking[parking.pk]"
                  style="width: 49.7px; height: 100%; justify-content: center; align-items: center;"
                  class="is-flex has-text-centered has-background-success is-padding-small">
                  <i
                    class="fas fa-reply fa-rotate-180"
                    style="font-size: 2rem; color: white"></i>
                </div>
                <div class="column is-padding-left-xsmall is-padding-right">
                  <span class="is-flex is-align-items-center">
                    <b class="is-size-6">{{ parking.nature | lotTypeLabel }}&nbsp;</b>
                    <span
                      class="is-size-6"
                      v-for="(type, i ) in parking.parking_type"
                      :key="'type' + i">&nbsp;-&nbsp; {{ i > 0 ? ', ' : '' }}{{ type | lotSubtypeLabel }}&nbsp;</span>
                    <span
                      class="is-size-6"
                      v-if="parking.info">&nbsp;({{ parking.info }})&nbsp;</span>
                    <span
                      class="is-size-6"
                      v-for="(sale_mode, i ) in parking.sales_mode"
                      :key="'sale_mode' + i">&nbsp;{{ i > 0 ? ', ' : '' }}{{ sale_mode | salesmodeLabel }}&nbsp;</span>
                    <span
                      class="is-size-6"
                      v-if="parking.sale_price_ttc">&nbsp;-&nbsp;{{ parking.sale_price_ttc }} €</span>
                  </span>
                </div>
                <div class="column is-narrow">
                  <div class="field">
                    <input
                      type="checkbox"
                      :id="'check_parking' + idx"
                      :value="'check_parking' + idx"
                      v-model="childCheckParking[parking.pk]"
                      @change="updateCheckParking(parking.pk, $event.target.checked)"
                      class="switch is-rounded is-success">
                    <label :for="'check_parking' + idx">&nbsp;</label>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <!-- A QUOI CELA SERT ? UN EXEMPLE ?  -->
          <template v-else>
            <div
              v-for="(parking, idx) in reservation.parkings"
              :key="idx"
              style="border: solid 0.7px #EBEBEB"
              class="has-background-white is-padding-left is-padding-right">
              <div class="column">
                <span>
                  <b class="is-size-6">{{ parking.nature | lotTypeLabel }}&nbsp;</b>
                  <span
                    class="is-size-6"
                    v-for="(type, i ) in parking.parking_type"
                    :key="'type' + i">&nbsp;-&nbsp;{{ i > 0 ? ', ' : '' }}{{ type | lotSubtypeLabel }}&nbsp;</span>
                  <span
                    class="is-size-6"
                    v-if="parking.info">&nbsp;({{ parking.info }})&nbsp;</span>
                  <span
                    class="is-size-6"
                    v-for="(sale_mode, i ) in parking.sales_mode"
                    :key="'sale_mode' + i">{{ i > 0 ? ', ' : '' }}{{ sale_mode | salesmodeLabel }}</span>
                  <span v-if="parking.sale_price_ttc">&nbsp;-&nbsp;{{ parking.sale_price_ttc }} €</span>
                </span>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { DefaultValues } from '@/mixins'

export default {
  name: 'PricePreResa',
  filters: {
    tvaLabelRounded (value) {
      if (value.toString().split('.').length === 1) {
        return `${value}.0`
      } else {
        return value
      }
    }
  },
  mixins: [DefaultValues],
  props: {
    selectedPack: {
      required: true
    },
    packList: {
      type: Array,
      required: true
    },
    lot: {
      type: Object,
      required: true
    },
    reservation: {
      type: Object,
      required: true
    },
    tvaList: {
      type: Array,
      required: true
    },
    parkings: {
      type: Array,
      required: true
    },
    checkParking: {
      required: true
    }
  },
  data () {
    return {
      childSelectedPack: this.selectedPack,
      childCheckParking: this.checkParking
    }
  },
  computed: {
    ...mapState(['isAdmin', 'isPromoteur']),
    isPending () {
      return this.reservation.status === 'pending'
    }
  },
  watch: {
    // Changement de la prop
    selectedPack (newValue) {
      this.childSelectedPack = newValue
    },
    checkParking: {
      handler (newValue) {
        this.childCheckParking = { ...newValue }
      },
      deep: true
    }
  },
  methods: {
    updateSelectedPack (newVal) {
      if (newVal) {
        this.$store.commit('modifyCurrentReservation', { key: 'pack', value: newVal.pk })
      } else {
        this.$store.commit('modifyCurrentReservation', { key: 'pack', value: '' })
      }
      this.$emit('update:selectedPack', newVal)
    },
    updateCheckParking (pk, newValue) {
      this.$emit('update:checkParking', { pk: pk, newValue: newValue })
      this.$set(this.childCheckParking, pk, newValue)
    }
  }
}
</script>
